<template>
  <div class="mt-4">
    <UiOnClickOutside :do="closeStudentDropdown">
      <div
        v-if="!tabLeftNav"
        class="xl:mt-6 mt-[15px] flex justify-center cursor-pointer"
        @click="mobileLeftBar"
      >
        <div
          class="rounded-full min-w-[36px] h-9 lg:w-[54px] lg:h-[54px] lg:min-w-[54px] flex justify-center items-center"
          :class="isAssociatedStudentProfileActive && 'border-[2px] box-content border-purple-700'"
          @click="toggleIsOpen"
        >
          <span
            v-if="!currentStudent?.image"
            class="bg-primary-purple-200 border-border-color-light border text-primary-purple-600 w-full h-full font-inter text-xs leading-[18px] md:text-sm font-medium sm:text-sm rounded-full uppercase flex justify-center items-center"
          >
            {{ initials(`${currentStudent?.first_name} ${currentStudent?.last_name}`) }}
          </span>
          <span v-else class="min-w-[36px] h-9 lg:w-[54px] lg:h-[54px] lg:min-w-[54px]">
            <img
              v-if="currentStudent?.image"
              class="object-cover h-full w-full z-50 rounded-full"
              :src="currentStudent.image"
              alt="user image not found"
            />
          </span>
        </div>
      </div>
      <div
        v-else
        class="w-full rounded-lg relative bg-[#FFFFFF99]"
        :class="[dropdownContainerClass, dropdownContainerColor]"
        @click.stop="toggleIsOpen"
      >
        <div
          v-if="isCurrentStudentExist"
          class="w-full rounded-lg flex items-center relative justify-between"
        >
          <div
            v-if="isAssociatedStudentProfileActive"
            class="text-primary-purple-600 uppercase font-inter rounded-full min-w-[36px] h-9 lg:w-[54px] lg:h-[54px] lg:min-w-[54px]"
            :class="
              currentStudent &&
              !currentStudent?.image &&
              'bg-primary-purple-200 flex items-center justify-center'
            "
          >
            <img
              v-if="currentStudent?.image"
              class="object-cover rounded-full h-full w-full"
              :src="currentStudent.image"
              alt="user img not found"
            />
            <span v-else class="font-inter text-xs leading-[18px] font-medium sm:text-sm">
              {{ initials(`${currentStudent?.first_name} ${currentStudent?.last_name}`) }}
            </span>
          </div>
          <div class="text-primary-gray-700 font-inter ltr:ml-2 rtl:mr-2.5 truncate">
            <div class="text-sm font-medium truncate">
              {{ currentStudent?.first_name }} {{ currentStudent?.last_name }}
            </div>
            <div
              v-if="isAssociatedStudentProfileActive"
              class="text-primary-gray-400 font-normal text-xs truncate"
            >
              <span>{{ currentStudent?.email }}</span>
            </div>
          </div>
          <div class="ml-1">
            <Icon
              :icon="chevronIconDirection"
              :width="iconWidth"
              :height="iconHeight"
              :color="chevronIconColor"
            />
          </div>
        </div>
        <UiMenuDropDown
          :class="$style.dropDownPosition"
          :is-open="isOpen"
          :disabled-styles="true"
          class="flex flex-col absolute rounded-tl-lg rounded-tr-lg border-t-[1.5px] bg-primary-purple-50 pt-2.5 border-x-[1.5px] border-b-0 profile-dropdown"
        >
          <div
            class="items-center flex gap-2 h-auto border-primary-grey border-b py-2"
            :class="[hideSearchBar]"
          >
            <span class="absolute ltr:left-3 rtl:right-3">
              <Icon class="icon" icon="search" color="primary-grey-500" />
            </span>
            <input
              ref="searchInput"
              v-model="searchQuery"
              type="text"
              name="search"
              class="lg:h-11 h-9 pl-9 bg-primary-gray-50 text-primary-gray-500 focus:outline-none font-normal font-roboto w-full"
              :placeholder="$t(`placeholder.Search`)"
              @keyup="searchThroughApi ? getStudents() : filterData"
            />
          </div>
          <ul
            class="font-inter py-2 w-auto font-normal text-sm md:text-base text-text-color border-b border-primary-purple-100"
          >
            <li
              v-if="isCurrentStudentExist"
              class="flex ltr:flex-row rtl:flex-row-reverse items-center justify-between h-9 my-2"
            >
              <div
                class="bg-primary-purple-100 my-4 p-2.5 w-full h-auto flex items-center relative"
              >
                <div
                  class="text-text-color rounded-full min-w-[28px] min-h-[28px] h-7 w-7"
                  :class="
                    currentStudent &&
                    !currentStudent?.image &&
                    'bg-primary-purple-200 flex items-center justify-center'
                  "
                >
                  <img
                    v-if="currentStudent?.image"
                    class="object-cover rounded-full h-full w-full"
                    :src="currentStudent.image"
                    alt="user img not found"
                  />
                  <span
                    v-else
                    class="font-inter text-xs leading-[18px] font-medium sm:text-sm text-primary-purple-600"
                  >
                    {{ initials(`${currentStudent?.first_name} ${currentStudent?.last_name}`) }}
                  </span>
                </div>
                <div class="text-primary-gray-700 font-inter ltr:ml-2 rtl:mr-2.5 truncate">
                  <div class="text-sm font-medium truncate">
                    {{ currentStudent?.first_name }} {{ currentStudent?.last_name }}
                  </div>
                  <div class="text-xs truncate text-primary-gray-400">
                    <span>{{ currentStudent?.email }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="overflow-y-auto max-h-[120px] pb-1">
            <div v-if="filterData.length > 0" class="pt-1">
              <li
                v-for="(student, index) in filterData"
                :key="index"
                class="cursor-pointer flex text-base font-inter hover:bg-primary-purple-100 items-center"
                @click="switchStudent(student)"
              >
                <div class="p-2.5 w-full h-auto flex items-center relative">
                  <div
                    class="text-text-color rounded-full min-w-[28px] min-h-[28px] h-7 w-7"
                    :class="
                      student &&
                      !student?.image &&
                      'bg-primary-purple-200 flex items-center justify-center'
                    "
                  >
                    <img
                      v-if="student?.image"
                      class="object-cover rounded-full h-full w-full"
                      :src="student.image"
                      alt="user img not found"
                    />
                    <span
                      v-else
                      class="font-inter text-xs leading-[18px] font-medium sm:text-sm text-primary-purple-600"
                    >
                      {{ initials(`${student?.first_name} ${student?.last_name}`) }}
                    </span>
                  </div>
                  <div class="text-primary-gray-700 font-inter ltr:ml-2 rtl:mr-2.5 truncate">
                    <div class="text-sm font-medium truncate">
                      {{ student?.first_name }} {{ student?.last_name }}
                    </div>
                    <div class="text-xs truncate text-primary-gray-400">
                      <span>{{ student?.email }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </div>
            <div v-else class="flex justify-center items-center h-14">
              <NoRecordFound custom-class="lg:text-sm md:text-sm text-sm py-2" />
            </div>
          </ul>
        </UiMenuDropDown>
      </div>
    </UiOnClickOutside>
    <UserRoleSwitch v-show="isRoleSwitchVisible" ref="studentRoleSwitch" />
  </div>
</template>

<script>
import UiMenuDropDown from '@components/UiElements/UiMenuDropDown.vue'
import Icon from '@components/icons/icon.vue'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import { filterdData } from '@src/utils/generalUtil.js'

import { buildWhereQuery } from '@src/utils/filters/index.js'
import FILTER_KEYS from '@src/constants/filter-constants.js'
import UiOnClickOutside from '@components/UiElements/UiOnClickOutside.vue'
import { mapState, mapActions } from 'vuex'
import generalMixin from '@src/mixins/general-mixins.js'
import UserRoleSwitch from '@src/modules/header/UserRoleSwitch.vue'
import NoRecordFound from '@/src/components/BaseComponent/NoRecordFound.vue'

export default {
  components: {
    UiMenuDropDown,
    NoRecordFound,
    UiOnClickOutside,
    UserRoleSwitch,
    Icon,
  },

  mixins: [generalMixin],
  props: {
    isShowDropdown: { type: Boolean, default: false },
  },
  emits: ['closeStudentSwitchDropdown', 'openStudentSwitchDropdown'],

  data() {
    return {
      TENANT_ROLES,
      isOpen: false,
      isRoleList: false,
      searchQuery: '',
      searchThroughApi: false,
      isRoleSwitchVisible: false,
      studentList: [],
      forceRerender: 1,
      get currentStudent() {
        return JSON.parse(localStorage.getItem('currentActiveStudent'))
      },
      set currentStudent(value) {
        JSON.parse(localStorage.getItem('currentActiveStudent'))
      },
    }
  },
  computed: {
    ...mapState({
      activeRole: (state) => state.layout.activeRole,
      classId: (state) => state.layout.currentSectionScope.id,
      tabLeftNav: (state) => state?.layout?.tabLeftNav,
      isAssociatedStudentProfileActive: (state) => state.layout.isAssociatedStudentProfileActive,
      campusId: (state) => state.layout.currentCampusScope.id,
      activeStudent: (state) => state.student.activeStudent,

      dropdownContainerClass() {
        return this.isOpen
          ? 'border-t-0 border-[1.5px] border-x border-b rounded-bl-lg rounded-br-lg bg-primary-purple-50 p-2.5'
          : 'border-[1.5px] border rounded-lg p-2.5'
      },
      dropdownContainerColor() {
        return this.isAssociatedStudentProfileActive ? 'border-purple-700' : 'border-white'
      },
      chevronIconColor() {
        return this.isOpen ? 'primary-purple-700' : 'primary-gray-700'
      },
      iconWidth() {
        return this.isAssociatedStudentProfileActive ? '12' : '15'
      },
      iconHeight() {
        return this.isAssociatedStudentProfileActive ? '6' : '15'
      },
      chevronIconDirection() {
        return !this.isOpen
          ? !this.isAssociatedStudentProfileActive
            ? 'expandCollapse'
            : 'chevronBottom'
          : 'chevronUp'
      },
    }),
    /**
     * Filter Data
     * @returns {String} - filtered String
     * @description filter data from options list by input search query returning the filtered list.
     */
    filterData() {
      const query = this.searchQuery.toLowerCase()
      return this.studentList ? filterdData(query, this.studentList, this.currentStudent) : []
    },
    isCurrentStudentExist() {
      return this.currentStudent && Object.keys(this.currentStudent).length > 0
    },
    hideSearchBar() {
      let response
      if (this.studentList?.length <= 9 && !this.searchThroughApi) {
        response = 'hidden'
      } else {
        response = 'flex'
      }

      return response
    },
    ...mapState('layout', [
      'currentCampusScope',
      'currentSectionScope',
      'activeRole',
      'currentClassScope',
    ]),
    isLevelChange() {
      return this.currentCampusScope?.id + this.currentSectionScope?.id + this.currentClassScope?.id
    },
  },
  watch: {
    isLevelChange: {
      handler() {
        if (this.searchThroughApi) {
          this.getStudents()
        }
      },
    },
  },

  mounted() {
    if (
      this.isAssociatedStudentProfileActive &&
      [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SECTION_TEACHER].includes(
        this.activeRole,
      )
    ) {
      this.getStudents()
      this.searchThroughApi = true
    } else {
      this.studentList = JSON.parse(localStorage.getItem('guardianAssociatedStudents')) || []
    }
  },

  methods: {
    /**
     * Toggle student dropdown
     */

    getStudents() {
      const query = this.searchQuery.toLowerCase()
      const payload = { $where: { ...buildWhereQuery(FILTER_KEYS.ILIKE, 'search', query) } }
      this.getStudentsWithFilters(payload).then((res) => {
        this.studentList = res?.records
      })
    },
    closeStudentDropdown() {
      this.isOpen = false
      this.searchQuery = ''
      if (this.searchThroughApi) {
        this.getStudents()
      }
    },
    toggleIsOpen(event) {
      if (this.$refs.searchInput && this.$refs.searchInput.contains(event.target)) {
        return
      }
      this.searchQuery = ''
      if (this.searchThroughApi) {
        this.getStudents()
      }
      this.isOpen = !this.isOpen
      if (!this.isAssociatedStudentProfileActive) {
        this.$store.commit('layout/SET_GUARDIAN_AND_STUDENT_PROFILES', true)
        this.$refs['studentRoleSwitch']?.switchRoles(this.activeRole, false, false)
      }
      this.$emit('openStudentSwitchDropdown', this.isOpen)
    },
    mobileLeftBar() {
      this.$store.commit('layout/SET_TAB_LEFT_BAR')
    },
    toggleIsRoleList() {
      this.isRoleList = !this.isRoleList
    },
    closeIsOpen() {
      if (this.isOpen && this.searchQuery) {
        this.searchQuery = ''
      }
      this.isOpen = false
    },

    switchStudent(student) {
      localStorage.setItem('currentActiveStudent', JSON.stringify(student))
      if (student) this.$store.commit('student/SET_ACTIVE_STUDENT', true)

      this.$emit('closeStudentSwitchDropdown')

      if (
        [
          TENANT_ROLES.SUPER_ADMIN,
          TENANT_ROLES.CAMPUS_ADMIN,
          TENANT_ROLES.SECTION_TEACHER,
        ].includes(this.activeRole)
      ) {
        this.$router
          .push({ name: 'student-profile-mode', params: { student_id: student?.id || '' } })
          .then(() => {
            this.$router.go(0)
          })
      } else {
        this.$refs['studentRoleSwitch']?.switchRoles(this.activeRole, false, false)
      }

      this.forceRerender++
    },
    ...mapActions('student', ['getStudentsWithFilters']),
  },
}
</script>

<style lang="scss" module>
.dropDownPosition {
  top: auto;
  right: -1px;
  bottom: 68px !important;
  width: calc(100% + 2px);
  padding: 0;
  border: 1.5px solid var(--primary-purple-700);
  border-top-width: 1.5px;
  border-right-width: 1.5px;
  border-bottom-color: var(--primary-purple-100);
  border-bottom-width: 1.5px;
  border-left-width: 1.5px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
@media (max-width: 1023px) {
  .dropDownPosition {
    bottom: 49px !important;
  }
}
.profile-dropdown {
  bottom: 56px;
}
@media screen and (min-width: 1024px) {
  .profile-dropdown {
    bottom: 74px;
  }
}
</style>
